import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { Subject, takeUntil } from 'rxjs';
import { ODataService } from '@ui-kit/odata';
import * as moment from "moment";

@Component({
  selector: 'patient-details',
  templateUrl: './details.html'
})
export class PatientDetailsComponent {

  @Output() appIsDeleted: EventEmitter<any> = new EventEmitter<any>();

  public model: any;
  public selectableSettings: SelectableSettings = { enabled: true, mode: 'single' };
  public mySelection: any[] = [];
  public deletingQueueId = '';
  public errMessage = '';

  private isSaving = false;
  private readonly unsubscribe$ = new Subject<void>();


  @Input() set patient(patientData: any) {
    if (!patientData) {
      return;
    }

    patientData.appointments.map((o: any) => {
      o.isDeletable = moment(o.queue.date).toDate().getTime() > moment().startOf("day").toDate().getTime()
      o.queue.date = moment(Date.parse(o.queue.date)).format('DD.MM.yyyy');
      o.combinedData = `${o.queue.date} ${o.queue.combinedTime} ${o.queue.medicalAppointment.serviceProvider}`;
    })
    this.model = patientData;
  }


  constructor(private odata: ODataService) { }


  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


  public deleteAppointment(): void {
    if (!this.deletingQueueId) {
      return;
    }
    
    if (this.isSaving) { return; }
    this.isSaving = true;
    this.errMessage = ''

    this.odata.post('patientAppointments', { params: { action: "delete" }, body: { id: this.deletingQueueId } })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({ 
          next: (xx: any) => {
            this.isSaving = false;
            this.appIsDeleted.emit(this.model.id); 

            this.deletingQueueId = '';
            this.mySelection = []; 
          }, 
          error: (e: any) => {
            this.isSaving = false;
            this.errMessage = this.getErrorMessage(e);
          } 
        });


  }
  
  private getErrorMessage(e: any): string {
    let errMessage = (e?.error?.error?.message ?? 'Помилка').trim(); 

    switch (errMessage) {
      case 'todayAppointmentReletionRejected':
        return 'Призначення на сьогодні можна видалити тільки за телефонним дзвінком.';
      default:
        return 'Помилка';
    }
  }
}
